/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Sla_Response_WindowInputs */

const en_case_detail_sla_response_window = /** @type {(inputs: Case_Detail_Sla_Response_WindowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response window`)
};

const pt_br2_case_detail_sla_response_window = /** @type {(inputs: Case_Detail_Sla_Response_WindowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Janela de resposta`)
};

/**
* | output |
* | --- |
* | "Response window" |
*
* @param {Case_Detail_Sla_Response_WindowInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_sla_response_window = /** @type {((inputs?: Case_Detail_Sla_Response_WindowInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Sla_Response_WindowInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_sla_response_window(inputs)
	return pt_br2_case_detail_sla_response_window(inputs)
});